import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-597de915"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "viewScroll" }
const _hoisted_2 = ["data-index"]

import { computed, nextTick, onMounted, onUpdated, PropType, ref, watch } from "vue";

/**
 * 自定义滚动对象的宽度
 */
export interface IScrollDataItem {
    /**
     * 位置
     */
    index?: number;
    /**
     * 间隔
     */
    space?: string;
}


interface IPositionData {
    index: number,  // 位置索引
    top: number, // 距离顶部的位置
    height: number,  // 当前项的高度
    // 顶部的位置 + 当前项的高度 = 滚动盒子应用的高度
    boxHeight: number
}

//---------------------传入参数、回调、监听定义---------------------
//定义传入变量

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    /**
     * 固定间隔，如传入参数包含固定位置，以传入对象位置为准
     */
    spacing: {
        required: false,
        type: Number,
        default: 0,
    },
    /**
     * 布局方向
     */
    direction: {
        required: false,
        type: String as PropType<'col' | 'row'>,
        default: 'row',
    },

    /**
     * 列表
     */
    list: {
        required: true,
        type: Array as PropType<any | IScrollDataItem[]>,
        default: () => {
            return []
        },
    },

},
  setup(__props) {

const props = __props;



//定义监听事件
//watch(
//  () => props.test,
//  (newVal: any) => {
//    //变更执行事件
//  }
//);

//定义监听事件
watch(
    () => props.list,
    (newVal: any) => {
        //变更执行事件
        initData()
    }
);

//定义回调事件
// const emit = defineEmits<{
//  (e: "resultTag", test: string): void;
// }>();

//定义生命周期事件
onMounted(() => {
    //生命周期处理内容
    initData()
});


onUpdated(() => {
    let cellNode = cell.value
    if (cellNode) {
        cellNode.forEach((node) => {
            // 实际高度
            let height = props.direction === 'row' ? node.getBoundingClientRect().width : node.getBoundingClientRect().height;
            let index = +node.dataset.index
            let position = positionData.value[index]
            let gap = height - position.height
            // 当前node的实际高度，跟预估高度不一致
            if (gap) {
                // 更新当前node的位置信息
                positionData.value[index].height = height
                positionData.value[index].boxHeight += gap
                for (let i = index + 1; i < positionData.value.length; i++) {
                    // 更新当前node后面所有项的位置信息
                    positionData.value[i].top = positionData.value[i - 1].boxHeight
                    positionData.value[i].boxHeight += gap
                }
            }
        })
    }
})



const contentBoxHeight = computed(() => {
    return positionData.value[positionData.value.length - 1]?.boxHeight + 'px';
});


// ---------------------数据变量定义-------------------------

//容器真实高度
let containerHeight = ref(props.list.length * props.spacing);
//当前状态的索引
let startKey = ref(0);
// 当前结束标记
let endKey = ref(0);

//当前显示列表
let showList = ref([])
//容器dom节点
const refScrollMain = ref(null);
const cell = ref(null);
// 可视框显示的数据量
let showCount = ref(0)
//存储每一项的位置信息
let positionData = ref<IPositionData[]>([])


// ---------------------方法定义-------------------------


const initData = () => {
    let containerDomHeight = props.direction === 'row' ? refScrollMain.value.clientWidth : refScrollMain.value.clientHeight;
    // 可视框需要显示的数据量
    showCount.value = Math.ceil(containerDomHeight / props.spacing)


    if (positionData.value.length != props.list.length) {
        // 预估的位置信息
        positionData.value = props.list.map((item, index) => {
            return {
                index: index,
                top: index * props.spacing,
                height: props.spacing,
                // 当前项为最后一条数据，滚动盒子的预估高度
                // top值加上本身的高度，就能得知滚动盒子的预估高度
                // boxHeight: index * this.cellHeight + this.cellHeight
                boxHeight: (index + 1) * props.spacing
            }
        })
    }


    //选中的位置
    let chooseIndex = -1;

    for (let index = 0; index < props.list.length; index++) {
        const element = props.list[index];
        if (element.select) {
            chooseIndex = index
            break;
        }
    }

    // 实现虚拟滚动
    mainScroll(chooseIndex)
}

//滚动事件
const mainScroll = (targerPostion: number) => {
    //计算当前状态的索引
    let spac = props.direction === 'row' ? refScrollMain.value.scrollLeft : refScrollMain.value.scrollTop;

    // 可视区域第一行索引
    let startIndex = Math.max(getStartIndex(spac) - 2, 0)
    // 可视区域最后一行索引,并增加4个数量
    let endIndex = Math.min(startIndex + showCount.value + 4, props.list.length)


    if (startIndex !== startKey.value || endIndex != endKey.value) {
        startKey.value = startIndex
        endKey.value = endIndex;
        // 获取需要渲染的数据
        showList.value = [...props.list.slice(startIndex, endIndex)]
    }

    //继续优化，追加内容显示不全的时候，自动移动位置
    if (targerPostion != -1) {
        let isMove = false;
        //左侧匹配
        let postionItem = positionData.value[targerPostion];
        let marinLeft = props.direction === 'row' ? refScrollMain.value.scrollLeft : refScrollMain.value.scrollTop;
        let marinWidth = props.direction === 'row' ? refScrollMain.value.clientWidth : refScrollMain.value.clientHeight;
        //移动差值
        let gap = 0;
        if (marinLeft > postionItem.top) {
            isMove = true;
            gap = marinLeft - postionItem.top;
        } else if ((marinLeft + marinWidth) < (postionItem.top + postionItem.height)) {
            isMove = true;
            gap = postionItem.top + postionItem.height - (marinLeft + marinWidth);
        }

        if (isMove) {
            //支持纵向排列和横向排列
            if (props.direction === 'row') {
                refScrollMain.value.scrollLeft += gap;
            } else {
                refScrollMain.value.scrollTop += gap;
            }
        }
    }

};


// 获取可视区域第一行索引
const getStartIndex = (spac: number) => {
    // 暴力搜索
    // let startIndex = this.positionData.findIndex(item => {
    //   return item.boxHeight > scrollTop
    // })
    // 二分查找
    let left = 0, right = positionData.value.length - 1, res = right
    while (left < right) {
        let mid = Math.floor((right - left) / 2) + left
        if (positionData.value[mid].boxHeight === spac) {
            return mid + 1
        } else if (positionData.value[mid].boxHeight > spac) {
            res = Math.min(mid, res)
            right = right - 1
        } else if (positionData.value[mid].boxHeight < spac) {
            left = mid + 1
        }
    }
    return res
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "viewJscroll",
    ref_key: "refScrollMain",
    ref: refScrollMain,
    onScroll: _cache[0] || (_cache[0] = ($event: any) => (mainScroll(-1)))
  }, [
    _createElementVNode("div", {
      class: "viewWrapper",
      style: _normalizeStyle({
            height: __props.direction === 'row' ? '100%' : _unref(contentBoxHeight), width: __props.direction
                === 'row' ? _unref(contentBoxHeight) : '100%'
        })
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(showList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "cell",
            ref_for: true,
            ref_key: "cell",
            ref: cell,
            key: index,
            "data-index": _unref(startKey) + index,
            style: _normalizeStyle({ left: __props.direction === 'row' ? _unref(positionData)[_unref(startKey) + index].top + 'px' : '0px', top: __props.direction === 'row' ? '0px' : _unref(positionData)[_unref(startKey) + index].top + 'px' })
          }, [
            _renderSlot(_ctx.$slots, "cell", {
              data: item,
              index: _unref(startKey) + index,
              offsetIndex: index
            })
          ], 12, _hoisted_2))
        }), 128))
      ])
    ], 4)
  ], 544))
}
}

})